// @ts-check

/**
 * @template C
 */
class ResultsLoadingManager {

    /**
     * @param {C} nullValue 
     */
    constructor(nullValue) {
        // this.loadingBufferBacking = new ArrayBuffer(4);
        // this.loadingBuffer = new Int32Array(this.loadingBufferBacking);
        /** @type {C} */
        this.nullValue = nullValue;
        /** @type {number} */
        this.currentLoading = 0;
        /** @type {Object.<number, C>} */
        this.loadingMap = {};
    }


    /**
     * @returns {number}
     */
    getCurrentLoadingId() { return this.currentLoading; }


    /**
     * @returns {number}
     */
    generateLoadingId() {
        return (Math.random() * 10000) | 0; // | 0 converts it to 32-bit int.
    }

    /**
     * @param {number} loadingId 
     * @return {void}
     */
    setActiveLoadingId(loadingId) {
        const old = this.currentLoading;
        this.currentLoading = loadingId;
        if (loadingId !== old && old in this.loadingMap) {
            delete this.loadingMap[old]; 
        }
        //const old = Atomics.load(this.loadingBuffer, 0);
        //Atomics.store(this.loadingBuffer, 0, loadingId);
        //if (old != loadingId && old in this.loadingMap) { delete this.loadingMap[old]; }
    }

    /**
     * @param {number} loadingId 
     * @param {C} contents
     * @return {void}
     */
    setContentsIfStillActive(loadingId, contents) {
        const currentId = this.currentLoading; //Atomics.load(this.loadingBuffer, 0);
        if (loadingId === currentId) {
            this.loadingMap[loadingId] = contents;
        }
    }

    /**
     * @returns {C}
     */
    retrieveCurrentResults() {
        const loadingId = this.currentLoading; //Atomics.load(this.loadingBuffer, 0);
        if (loadingId in this.loadingMap) {
            return this.loadingMap[loadingId];
        }
        else return this.nullValue;
    }

    /**
     * @param {function(C): void} setter 
     * @returns {{
     *  generateLoadingIdAndSetAsActive: function(): number,
     *  setResultsIfCurrentLoadingId: function(number, C): void,
     * }}
     */
    generateCombinedMethodsFromSetter(setter) {
        const thisObj = this;
        return {
            generateLoadingIdAndSetAsActive: () => {
                const id = thisObj.generateLoadingId();
                thisObj.setActiveLoadingId(id);
                return id;
            },
            setResultsIfCurrentLoadingId: (loadingId, results) => {
                thisObj.setContentsIfStillActive(loadingId, results);
                setter(thisObj.retrieveCurrentResults());
            }
        };
    }
    
}

export default ResultsLoadingManager;